import { useParameterizedAsyncData } from "src/utils/async/parameterizedAsyncData.ts";
import { ShopOrderBomTreeViewApi } from "src/api/generated/erp/production/api/shopOrderBomTreeViewApi.ts";
import { AsyncRender } from "src/components/common/async/AsyncRender.tsx";
import { ShopOrderBomTreeViewResult } from "src/api/generated/erp/production/api/shopOrderBomTreeViewResult.ts";
import { PartRevisionBomTreeViewBase } from "src/components/views/erp/parts/treeViews/PartRevisionBomTreeViewBase.tsx";
import { PartRevisionBomTreeItemModel } from "src/components/views/erp/parts/treeViews/treeItemMapping.ts";

export interface ShopOrderBomTreeViewProps {
	shopOrderId: number;
	onSelectionChanged: (selectedItem: PartRevisionBomTreeItemModel | null) => void;
}

export const ShopOrderBomTreeView = ({ shopOrderId, onSelectionChanged }: ShopOrderBomTreeViewProps) => {
	const { dataAsync, refresh } = useParameterizedAsyncData<
		ShopOrderBomTreeViewResult,
		ShopOrderBomTreeViewParams
	>({
		fetchData: ({ searchQuery }) =>
			ShopOrderBomTreeViewApi.getTreeElements({
				shopOrderId: shopOrderId,
				searchQuery: searchQuery,
			}),
		initialParams: {
			searchQuery: "",
		},
	});

	return (
		<AsyncRender
			asyncData={dataAsync}
			reloadOnError={() => refresh()}
			content={(data) => (
				<PartRevisionBomTreeViewBase
					treeElements={data.treeElements}
					onSearchQueryChange={(searchQuery) => refresh({ searchQuery })}
					onSelectionChanged={onSelectionChanged}
				/>
			)}
		/>
	);
};

interface ShopOrderBomTreeViewParams {
	searchQuery: string;
}
